export default "__VITE_PUBLIC_ASSET__6002c1d0__"